export const adminEnvironment = {
  production: false,
  aws: {
    cognito: {
      userPoolId: 'ca-central-1_WqrJOBuV2',
      userPoolWebClientId: '479q2v5j9grv77g2c0glv61lhi',
      region: 'ca-central-1',
      oauth: {
        domain: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_aGhy3fXZc',
        logout_domain: `https://ca-central-1aghy3fxzc.auth.ca-central-1.amazoncognito.com`,
        scope: 'openid email phone profile',
        redirectSignIn: 'https://toob-ecommerce.com/admin/admin-callback',
        redirectSignOut: 'https://toob-ecommerce.com/admin/logout',
        responseType: 'code',
      },
    },
    apiGateway: {
      domain: `https://puwttty3ne.execute-api.ca-central-1.amazonaws.com`,
      env: `dev`,
    },
  },
};
